// --------------------------------------- Project List
import Img from '../components/Assets/ProjectImages/pluralsight.png'
export const ProjectList = [
  {
    img: "https://masai-course.s3.ap-south-1.amazonaws.com/users/1185/submissions/103746/245972/5fee72dbd7bfea897a63f24fd3492886/Screenshot%20(1101).png",
    title: "Medium Clone",
    description: "Medium is an American online publishing platform developed by Evan Williams and launched in August 2012. It is owned by A Medium Corporation",
    tech_stack: "React | Javascript | Express | Mongo | HTML | CSS | Node.js | Google Auth",
    github_url: "https://github.com/prajal-Bankoti/medium_clone",
    demo_url: "https://medium-clone-prajal.vercel.app/",
    res:"I colne the whole UI using React, CSS and I build all features etc."
  },
  {
    img: "https://masai-course.s3.ap-south-1.amazonaws.com/users/1185/submissions/119660/282132/bb1e0e652a888be87fc0938bf0f233f3/pluralsight.png",
    title: "Pluralsight Clone",
    description: "Pluralsight is an educational website that offers courses for software developers.",
    tech_stack: "Html | Javascript | ExpressJS  | MongoDB  | CSS | Node.JS | Mongoose",
    github_url: "https://github.com/biswajitdas-007/Pluralsight",
    demo_url: "https://pluralsightclone-1.herokuapp.com/",
    res:"We clone the whole UI using HTML, CSS and we build Sign-in/Sign-up features etc."
  },
  {
    img: "https://user-images.githubusercontent.com/76935781/135754441-f335e4ec-c6fa-4675-860e-aa81b07e8a4b.png",
    title: "AbhiBus",
    description:
      "AbhiBus is India’s leading online travel booking brand.",
    tech_stack: "React | Javascript | Express | Mongo | HTML | CSS | dbjson | Firebase",
    github_url: "https://github.com/nagendrax02/abhibus-react-app",
    demo_url: "https://abhibus-clone.vercel.app/",
   res:" We build firebase otp based login feature Sorting hotel according to the category feature Searching etc."
  },

];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "https://camo.githubusercontent.com/49fbb99f92674cc6825349b154b65aaf4064aec465d61e8e1f9fb99da3d922a1/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f68746d6c352d2532334533344632362e7376673f7374796c653d666f722d7468652d6261646765266c6f676f3d68746d6c35266c6f676f436f6c6f723d7768697465",
    name: "HTML",
  },
  {
    img: "https://camo.githubusercontent.com/e6b67b27998fca3bccf4c0ee479fc8f9de09d91f389cccfbe6cb1e29c10cfbd7/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f637373332d2532333135373242362e7376673f7374796c653d666f722d7468652d6261646765266c6f676f3d63737333266c6f676f436f6c6f723d7768697465",
    name: "CSS",
  },
  {
    img: "https://camo.githubusercontent.com/aeddc848275a1ffce386dc81c04541654ca07b2c43bbb8ad251085c962672aea/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f6a6176617363726970742d2532333332333333302e7376673f7374796c653d666f722d7468652d6261646765266c6f676f3d6a617661736372697074266c6f676f436f6c6f723d253233463744463145",
    name: "JavaScript",
  },
 {
  img: "https://camo.githubusercontent.com/a1eae878fdd3d1c1b687992ca74e5cac85f4b68e60a6efaa7bc8dc9883b71229/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f4e6f64652e6a732d3333393933333f7374796c653d666f722d7468652d6261646765266c6f676f3d6e6f6465646f746a73266c6f676f436f6c6f723d7768697465",
  name: "Node js",
},
{
  img: "https://camo.githubusercontent.com/ab4c3c731a174a63df861f7b118d6c8a6c52040a021a552628db877bd518fe84/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f72656163742d2532333230323332612e7376673f7374796c653d666f722d7468652d6261646765266c6f676f3d7265616374266c6f676f436f6c6f723d253233363144414642",
  name: "Rect js",
},
{
  img: "https://camo.githubusercontent.com/ec0d32e85caf4723d5182a75338c89f85a2c3679aed0c46c9ee9fd1c8dc2a316/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f6769742d2532334630353033332e7376673f7374796c653d666f722d7468652d6261646765266c6f676f3d676974266c6f676f436f6c6f723d7768697465",
  name: "Git",
},
{
  img: "https://camo.githubusercontent.com/c839570bc71901106b11b8411d9277a6a8356a9431e4a16d6c26db82caab7d62/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f4d6f6e676f44422d2532333465613934622e7376673f7374796c653d666f722d7468652d6261646765266c6f676f3d6d6f6e676f6462266c6f676f436f6c6f723d7768697465",
  name: "MongoDb",
},
{
  img: "https://camo.githubusercontent.com/22547aa007860433c23771dfd59d184297d9433adcf3082be8515a28a16cd875/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f76657263656c2d2532333030303030302e7376673f7374796c653d666f722d7468652d6261646765266c6f676f3d76657263656c266c6f676f436f6c6f723d7768697465",
  name: "MongoDb",
},
];


// {
//   img: "https://gurupawar.github.io/portfolio/assets/skill/html5.svg",
//   name: "HTML",
// },
// {
//   img: "https://gurupawar.github.io/portfolio/assets/skill/css3.svg",
//   name: "CSS",
// },
// {
//   img: "https://gurupawar.github.io/portfolio/assets/skill/javascript.svg",
//   name: "JavaScript",
// },
// {
//   img: "https://icon-library.com/images/node-js-icon/node-js-icon-17.jpg",
//   name: "Node js",
// },
// {
//   img: "https://biswajit-das.vercel.app/static/media/react.66f413e1.png",
//   name: "Rect js",
// },
// {
//   img: "https://gurupawar.github.io/portfolio/assets/skill/git.svg",
//   name: "Git",
// },
// {
//   img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQChl3FkpuPFwlR4wnK2ptXXUi9VtAYOklqA&usqp=CAU",
//   name: "MongoDb",
// },